import usePagination from '@/hooks/usePagination';
import { RecommendedActionsFilters } from '@/types/schema';

import { useRecommendedActionsQuery } from '../graphql/queries/generated/GetAIRecommendations';

function useRecommendedActions({
  filters,
  pageSize,
}: {
  filters: RecommendedActionsFilters;
  pageSize?: number;
}) {
  const { data, fetchMore, isFetching, totalCount } = usePagination(
    useRecommendedActionsQuery,
    {
      recommendationsFilters: {
        ...filters,
      },
    },
    {
      edgeKey: 'recommendedActions',
      pageSize,
      requestPolicy: 'cache-and-network',
    },
  );

  return {
    recommendations: data,
    totalCount,
    fetchMore,
    isFetching,
  };
}

export default useRecommendedActions;
